(function ($) {

    var validationProgressList = function (selector) {

        $(selector).each(function () {
            var $list = $(this);
            var $trigger = $('#' + $list.attr('data-trigger-control'));
            var $matchTrigger = $('#' + $list.attr('data-trigger-match-control'));
            var matchTest = function () {
                if ($trigger.val().length && $matchTrigger.val().length) {
                    if ($trigger.val() == $matchTrigger.val())
                        $list.find('li[data-match]').removeClass('pr-no').addClass('pr-yes');
                    else
                        $list.find('li[data-match]').removeClass('pr-yes').addClass('pr-no');
                } else
                    $list.find('li[data-match]').removeClass('pr-yes').removeClass('pr-no');
            };
            $trigger.keyup(function () {
                $list.find('li[data-rule]').each(function () {
                    if ($trigger.val().length == 0)
                        $(this).removeClass('pr-no').removeClass('pr-yes');
                    else if ($trigger.val().match(new RegExp($(this).attr('data-rule'))))
                        $(this).removeClass('pr-no').addClass('pr-yes');
                    else
                        $(this).removeClass('pr-yes').addClass('pr-no');
                })
                matchTest();
            });
            $matchTrigger.keyup(matchTest);
        });

    };
    $(function () {
        validationProgressList('.validationProgressList');
    });

})(jQuery);

$.validator.addMethod("stringcontainsnumberorsymbol", function (value, element, params) {
    var match;
    if (this.optional(element)) {
        return true;
    }

    return /^(?=.*(\d|_|\W)).+$/.test(value);
});

$.validator.unobtrusive.adapters.addBool("stringcontainsnumberorsymbol");
